import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { ISavedPlace } from "../../models/SavedPlace";
import { SavePlacesService } from "../../services/savedPlaces.service";

export const useGetAllSavedPlacesQuery = () => {
  return useQuery<ISavedPlace[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_SAVED_PLACES],
    queryFn: () => SavePlacesService.getAll().then((res) => res.data),
  });
};
